import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {AuthProvider} from './context/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Documentation from './pages/Documentation';
import TcgDocumentation from './pages/TcgDocumentation';
import Dashboard from './pages/Dashboard';
import ApiKeys from './pages/ApiKeys';
// Components
import Sitemap from './components/Sitemap';
import SitemapXML from './components/SitemapXML';
import RobotsTxt from './components/RobotsTxt';

// Admin Pages
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminApiKeys from './pages/AdminApiKeys';
import AdminSubscriptions from './pages/AdminSubscriptions';
import AdminBlockedIPs from './pages/AdminBlockedIPs';
import AdminMissingImages from './pages/AdminMissingImages';
import AdminTcgConfigs from './pages/AdminTcgConfigs';
import AdminTcgData from './pages/AdminTcgData';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Routes without layout */}
        <Route path="/sitemap.xml" element={<SitemapXML />} />
        <Route path="/robots.txt" element={<RobotsTxt />} />

        {/* Routes with layout */}
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/docs" element={<Documentation />} />
                <Route path="/docs/:tcg" element={<TcgDocumentation />} />
                <Route path="/sitemap" element={<Sitemap />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/api-keys"
                  element={
                    <ProtectedRoute>
                      <ApiKeys />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/users"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminUsers />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/api-keys"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminApiKeys />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/subscriptions"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminSubscriptions />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/blocked-ips"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminBlockedIPs />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/missing-images"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminMissingImages />
                    </ProtectedRoute>
                  }
                />

                <Route
                    path="/admin/tcg-data"
                    element={
                        <ProtectedRoute adminOnly>
                            <AdminTcgData/>
                        </ProtectedRoute>
                    }
                />

                  <Route
                  path="/admin/tcg-configs"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminTcgConfigs />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="*"
                  element={
                    <div className="text-center py-12">
                      <h1 className="text-2xl font-bold text-gray-900 mb-2">404 - Page Not Found</h1>
                      <p className="text-gray-600">The page you're looking for doesn't exist.</p>
                    </div>
                  }
                />
              </Routes>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </Layout>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;